import { render, staticRenderFns } from "./list-tpl.vue?vue&type=template&id=77713855&scoped=true"
import script from "./list-tpl.vue?vue&type=script&lang=js"
export * from "./list-tpl.vue?vue&type=script&lang=js"
import style0 from "./list-tpl.vue?vue&type=style&index=0&id=77713855&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77713855",
  null
  
)

export default component.exports